import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-apollo';

import Button from '../../../../../../components/global/Button';
import { AlbumWithGreetingVideo } from '../../../../../../graphql/queries/albums';
import Spinner from '../../../../../../components/global/Spinner';
import {
  isMemoryBook,
  isVGBContext,
  isVideoAlbum,
} from '../../../../../../util/album';
import MemoryBookContent from './components/MemoryBookContent';
import GroupVideoContent from './components/GroupVideoContent';
import VGBContent from './components/VGBContent';

const propTypes = {
  albumId: PropTypes.string.isRequired,
  onAddPhotos: PropTypes.func.isRequired,
  headerless: PropTypes.bool,
  dismissible: PropTypes.bool,
  onClose: PropTypes.func,
  onRequestClose: PropTypes.func,
};

const SpecialtyAlbumGreeting = ({
  albumId,
  onAddPhotos,
  headerless,
  dismissible = true,
  onClose,
  onRequestClose,
}) => {
  const { data: { album } = {}, loading: loadingAlbum } = useQuery(
    AlbumWithGreetingVideo,
    {
      variables: {
        id: albumId,
      },
      skip: !albumId,
    },
  );

  if (loadingAlbum || !album) {
    return (
      <div className="w-100 h-100 d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }

  const greetingVideo =
    album.greeting_video?.records?.[0] ??
    album.slideshow?.default_greeting_video;
  const isVideoAlbumBool = isVideoAlbum(album);
  const isMemoryBookBool = isMemoryBook(album);
  const isVGB = isVGBContext(album);

  return (
    <Fragment>
      {isMemoryBookBool && (
        <MemoryBookContent
          headerless={headerless}
          album={album}
          greetingVideo={greetingVideo}
          onAddPhotosClick={() => {
            onClose?.();
            onAddPhotos();
            onRequestClose?.();
          }}
        />
      )}
      {isVideoAlbumBool && !isVGB && (
        <GroupVideoContent
          headerless={headerless}
          album={album}
          greetingVideo={greetingVideo}
        />
      )}
      {isVideoAlbumBool && isVGB && (
        <VGBContent
          headerless={headerless}
          album={album}
          greetingVideo={greetingVideo}
        />
      )}
      <div className="d-flex w-100 flex-column align-items-center mt-4">
        {!isMemoryBookBool && (
          <Button
            onClick={() => {
              onClose?.();
              onAddPhotos();
              onRequestClose?.();
            }}
          >
            {isVideoAlbumBool && isVGB ? (
              <>Add my message</>
            ) : (
              <>Add {isVideoAlbumBool ? 'videos' : 'photos'} now</>
            )}
          </Button>
        )}

        {dismissible && (
          <Button
            btnStyle="link"
            className="mt-2 text-extra-bold text-center"
            onClick={() => {
              onClose?.();
              onRequestClose?.();
            }}
          >
            Maybe later
          </Button>
        )}
      </div>
    </Fragment>
  );
};

SpecialtyAlbumGreeting.propTypes = propTypes;

export default SpecialtyAlbumGreeting;
